import { COURSE_DESCRIPTION_FOLD } from '@lib/data/course-landing-page'
import { CourseNameType } from '@lib/types/course-landing-page'
import { useRef, useState } from 'react'

type Props = {
  courseName: CourseNameType
  hideReadMore?: boolean
}

const CourseDescription = ({ courseName, hideReadMore }: Props) => {
  const [showDescription, setShowDescription] = useState(false)

  const coursesData = COURSE_DESCRIPTION_FOLD[courseName]
  const descriptionRef = useRef<HTMLDivElement>(null)

  const tagColors = [
    'bg-blue-100 bg-opacity-50',
    'bg-orange2-400 bg-opacity-50',
    'bg-red-100 bg-opacity-50',
    'bg-green-100 bg-opacity-50',
    'bg-violet-100 bg-opacity-50',
    'bg-orange bg-opacity-50',
  ]

  return (
    <div className="mb-10 flex flex-col text-grey lg:px-3 py-5">
      <h2 className="text-2xl font-600 mb-4 leading-tight">
        {coursesData.title}
      </h2>
      <div
        className="lg:text-lg overflow-hidden transition-all duration-700"
        style={{
          maxHeight:
            (!coursesData.description || showDescription) &&
            descriptionRef.current
              ? `${descriptionRef.current.clientHeight + 12}px`
              : '77px',
        }}
      >
        <div ref={descriptionRef}>
          {coursesData.description && <p>{coursesData.description}</p>}
          <p className="flex flex-col space-y-4 mt-4">
            {coursesData.expandedDescription}
          </p>
        </div>
      </div>
      {!hideReadMore && (
        <>
          {coursesData.readMoreLink && (
            <a
              href={coursesData.readMoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className="underline text-left mt-3 focus:outline-none hover:text-orange"
            >
              Read more
            </a>
          )}
          {!coursesData.readMoreLink && (
            <button
              onClick={() => setShowDescription(!showDescription)}
              className="underline text-left mt-3 focus:outline-none hover:text-orange"
            >
              Show {showDescription ? 'less' : 'more'}
            </button>
          )}{' '}
        </>
      )}
      {coursesData?.tags && coursesData.tags.length > 0 && (
        <div className="flex flex-wrap gap-2 mt-4">
          {coursesData.tags.map((tag, index) => (
            <span
              key={index}
              className={`${
                tagColors[index % tagColors.length]
              } px-2 py-1 text-sm rounded-full font-600`}
            >
              {tag}
            </span>
          ))}
        </div>
      )}
    </div>
  )
}

export default CourseDescription
